/* import __COLOCATED_TEMPLATE__ from './color-palettes-row.hbs.js'; */
import { computed } from "@ember/object";
import { htmlSafe } from "@ember/template";
import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const ColorPalettesRow = dt7948.c(class ColorPalettesRow extends SelectKitRowComponent {
  get palettes() {
    return htmlSafe((this.item.colors || []).filter(color => color.name !== "secondary").map(color => `#${escape(color.hex)}`).map(hex => `<span class="palette" style="background-color:${hex}"></span>`).join(""));
  }
  static {
    dt7948.n(this.prototype, "palettes", [computed("item.colors.[]")]);
  }
  get backgroundColor() {
    const secondary = (this.item.colors || []).findBy("name", "secondary");
    if (secondary && secondary.hex) {
      return htmlSafe(`background-color:#${escape(secondary.hex)}`);
    } else {
      return "";
    }
  }
  static {
    dt7948.n(this.prototype, "backgroundColor", [computed("item.colors.[]")]);
  }
}, [classNames("color-palettes-row")]);
export default ColorPalettesRow;